import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationSaxoData } from './Data';

export type IntegrationSaxoState = BaseIntegrationState;

export class IntegrationSaxoModel extends BaseIntegration<IntegrationSaxoData, IntegrationSaxoState> {
  authorSignature(): string {
    return 'Ani Mikova';
  }

  hasVueComponent() {
    return false;
  }
}
